import { useReducer, useState } from 'react'
import { BrowserRouter } from 'react-router-dom'
import AuthorizedLayout from './components/layout/AuthorizedLayout'
import DefaultLayout from './components/layout/DefaultLayout'
import UserContext, { userReducer, defaultUserValue, localUserData } from './context/userContext'
import LoadingContext from './context/loadingContext'
import { ModalLoading } from './components/shared'
import { useDisclosure } from '@chakra-ui/hooks'
import ScrollToTop from './components/shared/ScrollToTop'

const App = () => {
  const value = localUserData()
  const [userData, dispatchUserData] = useReducer(userReducer, value ? JSON.parse(value) : defaultUserValue)
  const { onClose, onOpen, isOpen } = useDisclosure()
  const [message, setMessage] = useState("")

  return (
    <BrowserRouter>
      <ScrollToTop />
      <LoadingContext.Provider value={{ onClose, onOpen, isOpen, message, setMessage }}>
        <UserContext.Provider value={[userData, dispatchUserData]}>
          {
            userData.authorized ? <AuthorizedLayout /> : <DefaultLayout />
          }
        </UserContext.Provider>

        <ModalLoading onClose={onClose} isOpen={isOpen} message={message} />
      </LoadingContext.Provider>
    </BrowserRouter>
  );
}

export default App;
